export default "__VITE_ASSET__a7dd4dec__"